export enum QueryParam {
  startDate = 'di',
  endDate = 'df',
  filter = 'filtro',
}

export enum HomeFilterParam {
  servicePending = 'atendimento-pendente',
  waitingForCustomer = 'aguardando-cliente-retirar',
  deliveryFail = 'falha-na-entrega',
  pickupByDriver = 'rota-de-entrega',
  verifyConsignment = 'verificar-remessa',
}

export enum ReturnFilterParam {
  returnsInProgress = 'devolucoes-em-andamento',
}
